import { GenericProtocolContentData, ProtocolContent, ProtocolContentType, ProtocolType } from "../../entities";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../utils/ProtocolTypeUtils";
import GatewayRecordParser, { POSITION_ENTRY_TYPE, REPORT_TYPE_EXTENSION, SOG_COG_ENTRY_TYPE, } from './GatewayRecordParser';
export default class GenericRecordParser extends GatewayRecordParser {
    constructor(app) {
        super(app);
    }
    handlesRecord() {
        return true;
    }
    handlesProtocol(protocol) {
        return this.getTypeId(protocol) === FIXED_PROTOCOL_TYPE_IDS.GENERIC;
    }
    getProtocolType() {
        return ProtocolType.createRef(FIXED_PROTOCOL_TYPE_IDS.GENERIC);
    }
    getContentData(protocol) {
        const data = protocol.contents.find(({ type: { _id: contentTypeId } }) => contentTypeId === FIXED_PROTOCOL_CONTENT_TYPE_IDS.GENERIC)?.data;
        if (data === undefined) {
            return {
                record: { Id: '', Author: '', Entries: [], Extensions: [] },
            };
        }
        return data;
    }
    getExtensions(protocol) {
        if (protocol.deleted) {
            return [];
        }
        const data = this.getContentData(protocol);
        const reportTypeExtension = this.getReportTypeExtension(protocol);
        const extensions = [
            ...(data.record.Extensions || []).filter(({ Name: name }) => name !== reportTypeExtension.Name),
            reportTypeExtension,
        ];
        return extensions;
    }
    createEntries(protocol) {
        return this.getContentData(protocol).record.Entries;
    }
    parseProtocolContent(originalRecord) {
        const record = {
            ...originalRecord,
            Entries: originalRecord.Entries.filter((entry) => {
                return ![POSITION_ENTRY_TYPE, SOG_COG_ENTRY_TYPE].includes(entry.Type);
            }),
            Extensions: (originalRecord.Extensions || []).filter((extension) => {
                return extension.Name !== REPORT_TYPE_EXTENSION;
            }),
        };
        const protocolContent = [
            new ProtocolContent({
                type: ProtocolContentType.createRef(FIXED_PROTOCOL_CONTENT_TYPE_IDS.GENERIC),
                data: new GenericProtocolContentData(record),
            }),
        ];
        return protocolContent;
    }
}
//# sourceMappingURL=GenericRecordParser.js.map